import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'

export const getRequestOperationalStatusQueryKey = (requestId: string) => ['requestOperationalStatus', requestId]

export const useGetRequestOperationalStatus = ({ requestId, enabled = true }: { requestId: string; enabled?: boolean }) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery({
    queryKey: getRequestOperationalStatusQueryKey(requestId),
    staleTime: 60_000,
    enabled,
    queryFn: async () => {
      const apiClient = new RequestsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/{id}/operational-status', {
        params: { path: { id: requestId } },
      })
      // 404 = org flag off, request soft-deleted, or no status generated yet — all "nothing to show".
      if (error?.type === 'NotFoundError') return null
      throwIfApiError(error)
      return data ?? null
    },
  })
}
